import { render, staticRenderFns } from "./SkupKotizacijaCreate.vue?vue&type=template&id=9690544a&scoped=true&"
import script from "./SkupKotizacijaCreate.vue?vue&type=script&lang=js&"
export * from "./SkupKotizacijaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9690544a",
  null
  
)

export default component.exports